import { useTranslation } from "../hooks/useTranslation";
import VideoPlayer from "./VideoPlayer";
import { useElementPosition } from "../hooks/useElementPosition";
import Swirl from "../icons/swirl.svg";
//import People from "../images/people.png";
import Ball1 from "../icons/pall1.svg";
import Ball2 from "../icons/pall2.svg";
import Ball3 from "../icons/pall3.svg";

const Hero = ({ lang }) => {
  const { t } = useTranslation();
  const [ref, position] = useElementPosition();
  let top = position.top / 10;
  return (
    <section
      ref={ref}
      className="hero"
      aria-labelledby="hero-title"
      role="region"
      style={{ backgroundImage: `url(${Swirl})` }}
    >
      <div className="hero-wrapper">
        <div className="hero-banner">
          <div className="ball">
            <img src={Ball1} />
          </div>
          <div className="ball">
            <img src={Ball2} />
          </div>
          <div className="ball">
            <img src={Ball3} />
          </div>
          {lang !== "ru" ? (
            <>
              <h1>
                Bingo loto
                <br />
                sünnipäeva
                <br />
                loos
              </h1>
              <img src="/bingo/assets/images/people.png" />
            </>
          ) : (
            <>
              <h1 className="rus">
                Розыгрыш&nbsp;ко
                <br /> дню&nbsp;рождения
                <br /> Bingo&nbsp;loto!
              </h1>{" "}
              <img src="/bingo/assets/images/people.png" />
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;
